/**
 * Created by calhosh on 5/2/2023
 */
import * as types from '../actiontypes';
export const updateStorybook = (formData) => {
	return {
		type: types.UPDATE_STORYBOOK,
		response: formData
	};
};
